const SupplychainCard = ({
  icon,
  title,
  value,
  description,
  descriptionBgColor,
  width = "355px",
  ClassName = "",
  descriptionClassName = "",
  descriptionClassName1 = "",
}) => {
  return (
    <div
      className={` bg-[#E8F4F8] rounded-[20px] shadow-md pt-6 h-full flex flex-col justify-between `}
      // style={{ width: `${width}` }}
      // style={{border:"1px solid red",height:"6"}}
    >
      {/* Icon & Title */}
      <div className="flex items-center space-x-4 pl-4">
        <div className=" p-2 rounded-lg shadow-sm flex items-center justify-center w-12 h-12">
          {typeof icon === "string" ? (
            <img src={icon} alt={title} className="w-8 h-8 object-contain" />
          ) : (
            <span className={`text-[#42B4A6] text-3xl`}>{icon}</span>
          )}
        </div>
        <span className="text-gray-800 text-[18px] font-semibold capitalize">
          {title}
        </span>
      </div>

      {/* Value */}
      <div
        className={`${ClassName} text-4xl font-bold text-gray-900 mt-6 text-center`}
      >
        {value}
      </div>

      {/* Description */}
      <div
        className={`text-white text-sm md:text-base px-4 md:px-6 rounded-b-[20px] py-3 mt-6 font-calibri text-center h-16  leading-snug ${descriptionClassName}`}
        style={{ backgroundColor: descriptionBgColor }}
      >
        {description}
      </div>
    </div>
  );
};

export default SupplychainCard;
